var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrafficCone = function SvgTrafficCone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.152 22.608C281.183 8.663 269.635 0 256.014 0c-13.639 0-25.197 8.663-30.165 22.608L87.355 411.3h337.29zM199.42 141.614h113.16l13.252 37.19H186.168zm-62.303 174.855h237.766l13.251 37.19H123.866zM441.647 426.36H70.353c-19.043 0-35.215 12.498-40.762 29.72h452.818c-5.548-17.222-21.72-29.72-40.762-29.72M27.583 471.128C28.606 493.838 47.396 512 70.353 512h371.294c22.957 0 41.747-18.162 42.77-40.872z"
  })));
};
export default SvgTrafficCone;